import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["index", "relationFieldKey", "Render"],
      _excluded2 = ["prefix", "index", "total", "minCount", "config", "onDelete", "relationFieldKey", "Render"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: your name
 * @Date: 2020-12-25 10:30:40
 * @LastEditTime: 2022-01-09 15:33:08
 * @LastEditors: wangshengqiang
 * @Description: In User Settings Edit
 * @FilePath: /za-dplatform-product-life/Users/zhongan/project/za-dplatform-main/za-dplatform-h5/src/components/Insurant/index.js
 */

/* eslint-disable import/prefer-default-export */
// 投保人模块 支持多被保人
// 内涵业务逻辑 当关系未本人时不展示其他表单字段  非本人时展示其他字段
import React, { useEffect } from 'react';
import { updateFormKey } from '@/utils/tool';
import { getStatePath } from '@/utils/utils';
import { getState, dispatch, useStore, getFormValue, setFormValue } from '@/store';
import { AddableBlock, DeletableBlock } from '../common';
import './index.less';

const delUndefineValue = obj => {
  Object.keys(obj).forEach(key => {
    if (obj[key] === undefined) {
      delete obj[key];
    }
  });
  return obj;
}; // 一组被保人表单
// config 一组被保人组件信息配置


function InsurantItem(props) {
  const {
    index,
    relationFieldKey,
    Render
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  let {
    config
  } = props;
  config = updateFormKey(config, index);
  const relationFormKey = getStatePath(config[0].formKey, 'holderRelation');
  const relationValue = useStore(`formValues.${relationFormKey}`);
  useEffect(() => {
    if (relationValue === 'self') {
      const insured = getFormValue(`insured[${index}]`);
      const holder = getFormValue('holder');

      const newInsure = _objectSpread(_objectSpread(_objectSpread({}, insured), holder), {}, {
        holderRelation: relationValue
      });

      setFormValue(`insured[${index}]`, newInsure);
    } else {// const insured = getFormValue(`insured[${index}]`) || {};
      // if(insured.holderRelation === relationValue) {
      //   return;
      // }
      // const hod = getState('orderDetail') || {};
      // const { insuredList = [] } = hod;
      // const TBR = insuredList?.[`${index}`]?.person || {};
      // setFormValue(`insured[${index}]`, {
      //   name: '',
      //   ...TBR,
      //   holderRelation: relationValue,
      // });
    }
  }, [relationValue]);

  if (!config || config.length === 0) {
    return null;
  } // 当关系选择的是自己的时候，把其他字段过滤掉
  // TODO: 这里过滤的话，会触发投被保人关系选本人时，不触发试算的问题，尝试注释后看是否能修复
  // if (relationValue === 'self') {
  //   const holder = getFormValue('holder');
  //   const holderFormKeys = Object.keys(holder);
  //   console.log('holder: ', holder);
  //   config = config.filter((item) => {
  //     const _formKey = item.formKey?.split('.')?.lastItem;
  //     return !holderFormKeys.includes(_formKey);
  //   });
  //   console.log('当关系为本人时的config: ', config);
  // }


  return /*#__PURE__*/React.createElement(Render, {
    components: config
  });
} // 多被保人使用


function InsurantRender(_ref) {
  let {
    prefix,
    index,
    total,
    minCount,
    config,
    onDelete,
    relationFieldKey,
    Render
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded2);

  return /*#__PURE__*/React.createElement(DeletableBlock, {
    title: `${prefix}${index + 1}信息`,
    index: index,
    deletable: total > minCount,
    onDelete: onDelete,
    content: `删除${prefix}${index + 1}信息`,
    headerClassName: "delete-block-header"
  }, /*#__PURE__*/React.createElement(InsurantItem, _extends({
    config: config,
    relationFieldKey: relationFieldKey,
    Render: Render,
    index: index
  }, rest)));
}

const Insurant = props => {
  var _getFormValue;

  const {
    attrs,
    Render,
    children
  } = props;
  let {
    prefix = '被保人',
    relationFieldKey = 'holderRelation',
    minInsuredCount,
    defaultInsuredCount,
    maxInsuredCount,
    type,
    factors = []
  } = attrs;
  const sessionInsuredLength = (_getFormValue = getFormValue('insured')) === null || _getFormValue === void 0 ? void 0 : _getFormValue.length;
  minInsuredCount = minInsuredCount || 1;
  defaultInsuredCount = sessionInsuredLength || defaultInsuredCount || 1;
  maxInsuredCount = maxInsuredCount || 1;
  useEffect(() => {
    const insured = getFormValue('insured') || [];
    const trailElement = getFormValue('trailElement');
    const insuredTrail = (trailElement === null || trailElement === void 0 ? void 0 : trailElement[1]) || [];
    let mapArr = [];

    if (insured.length > insuredTrail.length) {
      mapArr = insured;
    } else {
      mapArr = insuredTrail;
    }

    const insuredNext = mapArr.map((i, index) => {
      const item1 = insuredTrail[index] || {};
      let item2 = insured[index] || {};
      item2 = delUndefineValue(item2);
      return _objectSpread(_objectSpread({}, item1), item2);
    });
    setFormValue({
      insured: insuredNext
    });
    dispatch({
      maxInsurant: maxInsuredCount,
      minInsurant: minInsuredCount
    });
  }, []); // 多被保人

  if (maxInsuredCount > 1) {
    const handleCountChange = ({
      type: _type,
      count
    }) => {
      // 为了触发受益人也同步增加一个
      if (_type === 'add') {
        setFormValue(`insured[${count - 1}].name`, '');
      }
    };

    return /*#__PURE__*/React.createElement(AddableBlock, {
      Render: Render,
      prefix: prefix,
      formValueArrayKey: "insured",
      maxCount: maxInsuredCount,
      initCount: defaultInsuredCount,
      minCount: minInsuredCount,
      config: children,
      noUpdateConfig: true,
      type: type,
      addButtonText: `添加${prefix}`,
      Component: InsurantRender,
      onCountChange: handleCountChange,
      relationFieldKey: relationFieldKey
    });
  } // 单被保人


  return /*#__PURE__*/React.createElement(InsurantItem, {
    Render: Render,
    config: children,
    relationFieldKey: relationFieldKey,
    index: 0
  });
};

export default Insurant;